define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/NewController",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/xml",
	"Apparel/NewStyle",
	"Apparel/NewStyleForm",
], function(declare,lang,NewController,Field,Relationship,xml,NewStyle,NewStyleForm) {

	const SEASON = "ParentSeason";
	const CATEGORY1 = "Category1";
	const CATEGORY2 = "Category2";
	const COLLECTION = "Collection";
	const SHAPE = "Shape";
	const PRODUCT_TYPE = "ProductType";
	const PRODUCT_TEMPLATE = "Template";

	const _Form = declare(NewStyleForm, {
		/**@property override with true to avoid set the default values for theme and shape  fields in the form
		   @override */
		isShapeOrThemeContext: true,
		_addHierarchyField: function(id) {
			this.insertField(lang.mixin(new Field(), {
				m_id: id,
				m_bRequired: true,
				bForceEditable: true,
				bDisableExpressionEvaluation: true
			}), 0);
		},

		_addSeasonField: function(shape) {

			const shapeSeasons = shape.ShapeSeasons;
			if (shapeSeasons.length > 0) { // DE26668
				this.insertField(lang.mixin(new Field(), {
					m_id: SEASON,
					bForceEditable: true,
					m_bRequired: true,
					bDisableExpressionEvaluation: true,
					m_relationship: lang.mixin(new Relationship(), {
						m_url: shape.$URL,
						m_id: "ShapeSeasons"
					})
				}), 0);
			} else {
				this.insertField(lang.mixin(new Field(), {
					m_id: SEASON,
					bForceEditable: true,
					bDisableExpressionEvaluation: true,
					m_bRequired: true
				}), 0);
			}
		},

		/**
		 * @override
		 * Set Theme field as read only in case NewStyleForm change the visiblity of this.
		 */
		_updateFieldVisibility: function(field) {
			this.inherited(arguments);

			this.setFieldDisabled(SHAPE, true);
			return true;
		},

		_resolveView: function() {
			const	fd = this.defView.m_formData;
			const	shape = fd.getParent();

			this.addFixedValue(SHAPE, shape.$URL);

			this._addHierarchyField(COLLECTION);
			this._addHierarchyField(CATEGORY2);
			this._addHierarchyField(CATEGORY1);
			this._addSeasonField(shape);

			this.inherited(arguments);
		},
	});

	return declare(NewStyle, {
		/**
		 * Add special controller for Style create form
		 */
		onCreatePopupDefView: function(defView) {
			defView.classController = _Form;
		},

		toWriterRequest: function() {
			// summary: "use" hierarchy fields so they won't be published to server
			const	fd = this.getFormData();
			const urlCollection = fd.getFieldValue(COLLECTION, true);
			fd.getFieldValue(SEASON, true);
			fd.getFieldValue(CATEGORY1, true);
			fd.getFieldValue(CATEGORY2, true);

			let	call = NewController.prototype.toWriterRequest.call(this);
			call
				.addParameter(PRODUCT_TYPE, xml.ATTR_REF, fd.getFieldValue(PRODUCT_TYPE, true))
				.addParameter(PRODUCT_TEMPLATE, xml.ATTR_REF, fd.getFieldValue(PRODUCT_TEMPLATE, true))
				.addParameter(xml.ATTR_NAME, xml.ATTR_STRING, fd.getFieldValue(xml.ATTR_NAME, true))
				.addParameter("CollectionURL", xml.ATTR_REF, urlCollection)

			return call;
		}
	});
});